"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionStyled = exports.HeadlineStyled = exports.OverlineStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("../../helpers");

var _styled = require("../../styled");

var _const = require("./const");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      a {\n        color: ", ";\n        opacity: 1;\n        transition: opacity ease-in-out 0.3s;\n\n        &:hover {\n          opacity: 0.7;\n        }\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 300;\n  text-align: center;\n  ", ";\n  ", ";\n  p {\n    margin: 15px 0 0;\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  font-weight: 400 !important;\n  line-height: 1em;\n  word-wrap: break-word;\n  margin-bottom: -12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var maxWidthValue = '900px';
var OverlineStyled = (0, _uiKit.styled)(_uiKit.HeadingStyled)(_templateObject(), (0, _helpers.lineStyles)({
  styles: _const.defaultStyles,
  line: 'line1'
}), _styled.Line1Styles);
exports.OverlineStyled = OverlineStyled;
var HeadlineStyled = (0, _uiKit.styled)(_uiKit.HeadingStyled)(_templateObject2(), (0, _helpers.lineStyles)({
  styles: _const.defaultStyles,
  line: 'line2'
}), _styled.Line2Styles);
exports.HeadlineStyled = HeadlineStyled;
var DescriptionStyled = (0, _uiKit.styled)(_uiKit.TextStyled)(_templateObject3(), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return "max-width: ".concat(fullWidth ? '100%' : maxWidthValue);
}, function (_ref2) {
  var color = _ref2.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
}, function (_ref3) {
  var $descriptionLinkColor = _ref3.theme.$descriptionLinkColor;
  return (0, _uiKit.css)(_templateObject4(), $descriptionLinkColor ? _uiKit.Colors[$descriptionLinkColor] : 'currentColor');
});
exports.DescriptionStyled = DescriptionStyled;